import AGREGAR_LICITACION_CALENDARIO from '@/graphql/mutations/administracion/licitaciones/calendario/agregarLicitacionCalendario.gql';
import ACTUALIZAR_LICITACION_CALENDARIO from '@/graphql/mutations/administracion/licitaciones/calendario/actualizarLicitacionCalendario.gql';
import REMOVER_LICITACION_CALENDARIO from '@/graphql/mutations/administracion/licitaciones/calendario/removerLicitacionCalendario.gql';
import LICITACION_CALENDARIO from '@/graphql/querys/administracion/licitaciones/calendario/licitacionCalendario.gql';

export default {
  methods: {
    // Agregar Evento de Licitación.
    async mixAgregarEvento() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_LICITACION_CALENDARIO,
          variables: {
            evento: this.evento,
          },
          update: (store, { data: { agregarLicitacionCalendario } }) => {
            const query = {
              query: LICITACION_CALENDARIO,
              variables: {
                id: this.idLicitacion,
              },
            };
            const { licitacionCalendario } = store.readQuery(query);
            const licitacionCalendarioCopia = licitacionCalendario.slice();
            licitacionCalendarioCopia.push(agregarLicitacionCalendario);
            store.writeQuery({
              ...query,
              data: {
                licitacionCalendario: licitacionCalendarioCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar Evento de Licitación.
    async mixActualizarEvento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_LICITACION_CALENDARIO,
          variables: {
            id: this.eventoLicitacionEditar.id,
            evento: this.evento,
          },
          update: (store, { data: { actualizarLicitacionCalendario } }) => {
            const query = {
              query: LICITACION_CALENDARIO,
              variables: {
                id: this.eventoLicitacionEditar.idLicitacion,
              },
            };
            const data = store.readQuery(query);
            const { licitacionCalendario } = data;
            const index = licitacionCalendario
              .findIndex((eventoLicitacion) => eventoLicitacion.id
              === actualizarLicitacionCalendario.id);
            if (index !== -1) {
              licitacionCalendario.splice(index, 1, actualizarLicitacionCalendario);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Evento de Licitación.
    async mixEliminarEvento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_LICITACION_CALENDARIO,
        variables: {
          id: this.eventoLicitacionEliminar.id,
        },
        update: (store) => {
          const query = {
            query: LICITACION_CALENDARIO,
            variables: {
              id: this.eventoLicitacionEliminar.idLicitacion,
            },
          };
          const data = store.readQuery(query);
          const { licitacionCalendario } = data;
          const index = licitacionCalendario
            .findIndex((evento) => evento.id === this.eventoLicitacionEliminar.id);
          if (index !== -1) {
            licitacionCalendario.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
